import React, { useState } from 'react';
import TreeArchitectureApp from './components/TreeArchitectureApp';
import Login from './components/Login/Login';
import './App.css';

function App() {
  const [user, setUser] = useState(null);
  

  const handleLogin = (userData) => {
    console.log(userData)
    setUser(userData);
    // In production, store in localStorage or session
    localStorage.setItem('user', JSON.stringify(userData));
  };

  const handleLogout = () => {
    setUser(null);
    localStorage.removeItem('user');
  };

  // Check if user is already logged in (from localStorage)
  React.useEffect(() => {
    const storedUser = localStorage.getItem('user');
    if (storedUser) {
      setUser(JSON.parse(storedUser));
    }
  }, []);

  if (!user) {
    return <Login onLogin={handleLogin} />;
  }

  return <TreeArchitectureApp user={user} onLogout={handleLogout} />;
}

export default App;